import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class UserService extends BaseService {
	constructor() {
		super('/User');
	}

	public updatePassword(id: number, data: any) {
		return super.updateBase(this._resourceName + '/UpdatePassword/' + id, data);
	}

	public forgetPassword(id: number, data: any) {
		return super.updateBase(this._resourceName + '/ForgetPassword/' + id, data);
	}

	public validCode(code: string) {	
		return super.getByIdWithResourceName(1, this._resourceName + '/ValidateCode/' + code);
	}

	public login(data: any) {
		return super.createBase(this._resourceName + '/Login/', data);
	}

	public loginOut(data: any) {
		return super.createBase(this._resourceName + '/LoginOut/', data);
	}

	public registrationSelf(data: any) {
		return super.createBase(this._resourceName + '/RegistrationSelf/', data);
	}

	//michael
	public registration(data: any) {
		return super.createBase(this._resourceName + '/Registration/', data);
	}

	public changeTenant(data: any) {
		return super.createBase(this._resourceName + '/ChangeTenant/', data);
	}

	public userEnums(id: number ,data: any) {
		return super.updateBase(this._resourceName + '/UserEnums/' +id, data);
	}

	public getAllByFilter(filter: UserFilter) {
		return super.getAllByFilterBase(filter);
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

}

export class UserFilter extends BaseFilter {
	constructor(idTenant?: number | null, isTeacher?: boolean | null) {
		super();

			this._idTenant = idTenant;
			this._isTeacher = isTeacher;
	}

		private _idTenant?: number | null;
		private _isTeacher?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},

			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
				(this._isTeacher != null ? { IsTeacher: this._isTeacher } : {})

		);

		return data;
	};


}